import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import examActions from "../Redux/exam/actions";

const useFetchQuestion = ({
  currentSrNo,
  language,
  imageSize,
  questionsAndOptions,
  decryptedParams,
  projectDetails,
  handleEncodeJson,
  EncryptObjectFunction,
  isNavigate
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!decryptedParams || !currentSrNo || questionsAndOptions?.questionData?.srNo) {
      console.log(questionsAndOptions?.questionData?.srNo,decryptedParams,currentSrNo,'test');
      return;
    }

    const fetchData = async () => {
      const queryParams = {
        SrNo: currentSrNo,
        lang: language,
        img: imageSize,
      };

      const formData = {
        imageSize: `${imageSize}`,
        action: questionsAndOptions?.questionData?.status === "SKIPPED"
          ? "skip"
          : questionsAndOptions?.questionData?.status === "MARKED"
          ? "mark"
          : "next",
        currentSrNo,
        nextSrNo: currentSrNo,
        selectedAnswer: questionsAndOptions?.questionData?.selectedAnswer,
        language: `${language}`,
      };

      //const encodedData = await handleEncodeJson({ encodeJSON: formData });
      const encryptedParams = EncryptObjectFunction(queryParams);

      dispatch({
        type: examActions.GET_SUBMIT_ANSWER,
        payload: {
          formData: formData,
          navigate: (path) => {
            if (isNavigate) {
              navigate(`${path}?qNo=${encryptedParams}`);
            }
          },
          mockMode: projectDetails?.mockMode,
        },
      });
    };

    fetchData();
  }, [currentSrNo, language, imageSize, questionsAndOptions?.questionData?.srNo, decryptedParams]);

};

export default useFetchQuestion;
